// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/mutation-schedule-new-patient.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Old(
  $appointment_type_id: uuid!
  $location_id: uuid!
  $date: date!
  $start_time: time!
  $end_time: time!
  $chair_id: uuid!
  $patient_form: jsonb!
  $note: String
  $unplanned: Boolean!
  $lead_id: uuid
) {
  calendar_scheduling_admin_for_new_patient(
    args: {
      _appointment_type_id: $appointment_type_id
      _location_id: $location_id
      _date: $date
      _start_time: $start_time
      _end_time: $end_time
      _chair_id: $chair_id
      _patient_form: $patient_form
      _note: $note
      _unplanned: $unplanned
      _lead_id: $lead_id
    }
  ) {
    _id
    id
  }
}

`